import React from "react";
import i18n from "i18next";

const LANGS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
    { code: "kn", label: "ಕನ್ನಡ" },
  { code: "ml", label: "മലയാളം" }
];

export default function LanguageSwitcher() {
  const change = (e) => {
    const lng = e.target.value;
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
  };

  return (
    <select
      className="form-select form-select-sm"
      value={i18n.language || "en"}
      onChange={change}
      style={{
        width: 120,
        borderRadius: 8,
        cursor: "pointer"
      }}
    >
      {LANGS.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
